import { useScrollReveal } from '@/hooks/useScrollReveal';

const WHATSAPP_NUMBER = '+923348872555';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER.replace('+', '')}`;

export default function InvestmentSection() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section className="w-full py-16 md:py-24 bg-ivory-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div
          ref={ref}
          className={`grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center max-w-6xl mx-auto ${
            isVisible ? 'animate-fade-in-up' : 'opacity-0'
          }`}
        >
          {/* Content */}
          <div>
            <span className="inline-block text-xs md:text-sm font-semibold text-brand-orange uppercase tracking-widest mb-3">
              Smart Investing
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-charcoal-300 mb-5">
              Smart Investments Begin With Expert Guidance
            </h2>
            <p className="text-sm md:text-base text-charcoal-50 leading-relaxed mb-4">
              Real estate remains one of the most reliable wealth-building assets in Pakistan. But navigating the market requires expertise — understanding location dynamics, legal frameworks, payment structures, and future development plans.
            </p>
            <p className="text-sm md:text-base text-charcoal-50 leading-relaxed mb-6">
              At Sunshine Real Estate, we combine deep market knowledge with a client-first approach. Whether you're a first-time buyer or a seasoned investor, our advisory team ensures every decision is backed by data and aligned with your financial goals.
            </p>
            <div className="flex flex-wrap gap-3">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="px-6 py-3 bg-brand-orange text-white text-sm md:text-base font-semibold rounded-lg hover:bg-brand-orangeLight transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                Start Your Investment Journey
              </a>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="px-6 py-3 border border-charcoal-200 text-charcoal-300 text-sm md:text-base font-semibold rounded-lg hover:bg-charcoal-100/5 transition-all duration-300 whitespace-nowrap"
              >
                WhatsApp Advisor
              </a>
            </div>
          </div>

          {/* Visual */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20luxury%20residential%20development%20with%20gated%20community%20wide%20roads%20green%20spaces%20and%20modern%20houses%20at%20dusk%20golden%20hour%20aerial%20view%20Islamabad%20Pakistan%20high%20investment%20potential%20premium%20real%20estate&width=800&height=600&seq=501&orientation=landscape"
                alt="Investment Growth"
                className="w-full h-64 md:h-80 object-cover object-top"
              />
            </div>
            {/* Floating growth card */}
            <div className="absolute -bottom-4 -left-2 md:-left-6 bg-white rounded-xl p-4 shadow-xl border border-ivory-200">
              <div className="flex items-center gap-2 mb-1">
                <i className="ri-arrow-up-line text-brand-green font-bold" />
                <span className="text-lg font-extrabold text-charcoal-300">35% - 60%</span>
              </div>
              <div className="text-xs text-charcoal-50">Average annual appreciation on our recommended projects</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}